import React, { useState } from 'react'
import cn from 'classnames'
import Table from '../Table'
import toast from '../Toast'
import moment from 'moment'
import { termKeyPrefix } from './getCitySummaries'
import { saveDueDiligenceHistory, deleteDueDiligenceHistory } from '../../fire'
import { formatQuery } from './queryFormatOptions'

let CitySummary = ({
  showSaveHistory,
  showDeleteHistory = false,
  citySummary,
  termsArray,
  docId,
  dateCreated,
  showExpandBtn = false,
  savedHistoryIds,
  toggleSavedHistoryId,
}) => {
  let { city, stateCode, data, queryFormatId, resultId } = citySummary
  let [expanded, setExpanded] = useState(!showExpandBtn)
  let [saving, setSaving] = useState(false)
  let [deleting, setDeleting] = useState(false)

  return (
    <div>
      <h5
        className="d-flex align-items-center"
        style={{ cursor: 'pointer' }}
        onClick={() => setExpanded(!expanded)}
      >
        {showExpandBtn && (
          <i
            style={{ cursor: 'pointer' }}
            className={cn('fa mr-2 ', {
              'fa-angle-double-down': expanded,
              'fa-angle-double-up': !expanded,
            })}
          />
        )}{' '}
        <span className="text-nowrap">
          {city} {stateCode}
          <small className="ml-3">
            Format: {'"'}
            {formatQuery(queryFormatId, {
              term: termsArray[0],
              city,
              stateCode,
            })}
            {'"'}
          </small>
        </span>
        {showExpandBtn && (
          <small className="ml-3">
            {termsArray.map(term => (
              <span key={term} className="badge badge-secondary mr-1">
                {term}
              </span>
            ))}
          </small>
        )}
        {showSaveHistory && (
          <button
            className="btn btn-primary btn-sm ml-auto"
            disabled={saving || savedHistoryIds.includes(resultId)}
            onClick={async e => {
              e.stopPropagation()
              try {
                setSaving(true)
                await saveDueDiligenceHistory({ citySummary, termsArray })
                toggleSavedHistoryId(resultId)
              } catch (e) {
                toast.error(`${e}`)
              }
              setSaving(false)
            }}
          >
            {savedHistoryIds.includes(resultId) ? 'Saved' : 'Save'}
          </button>
        )}
        {showDeleteHistory && (
          <>
            <small className="ml-auto text-nowrap">
              {moment(dateCreated).format('MM/DD/YYYY h:mmA')}
            </small>
            <button
              className="btn btn-danger btn-sm ml-3"
              disabled={deleting}
              onClick={async e => {
                e.stopPropagation()
                try {
                  setDeleting(true)
                  await deleteDueDiligenceHistory(docId)
                } catch (e) {
                  toast.error(`${e}`)
                  setDeleting(false)
                }
              }}
            >
              Delete
            </button>
          </>
        )}
      </h5>
      {expanded && (
        <Table
          rowKey={r => r.placeId}
          rowStyle={r => ({
            backgroundColor: r.hasPotential ? '#8cff32' : undefined,
          })}
          columns={[
            {
              header: 'Place',
              key: 'name',
              render: ({ name, url }) => (
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {name}
                </a>
              ),
            },
            {
              header: 'Website',
              key: 'website',
              render: ({ website }) =>
                website && (
                  <a href={website} target="_blank" rel="noopener noreferrer">
                    {website}
                  </a>
                ),
            },
            ...termsArray.map(term => ({
              header: () => (
                <a
                  href={`https://www.google.com/search?q=${formatQuery(
                    queryFormatId,
                    {
                      term,
                      city,
                      stateCode,
                    }
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {term}
                </a>
              ),
              key: `${termKeyPrefix}${term}`,
            })),
          ]}
          data={data}
        />
      )}
    </div>
  )
}

export default CitySummary
